// AUTO-GENERATED BY SLDS BUILD SYSTEM - DO NOT EDIT
import "../components/accordion/default/script.js";
import "../components/banner/default/script.js";
import "../components/content-switcher/default/script.js";
import "../components/events-simple/default/script.js";
import "../components/gallery/default/script.js";
import "../components/global-modal/default/script.js";
import "../components/header/default/script.js";
import "../components/hero-area/carousel/script.js";
import "../components/infographics-grid/default/script.js";
import "../components/subnavigation/default/script.js";
